const el_imask = document.querySelectorAll('[data-imask-mask]');

if (el_imask.length) {
    for (const elImaskElement of el_imask) {
        IMask(elImaskElement, {
            // set mask format
            mask: elImaskElement.dataset.imaskMask
        });

    }
}

function currencyFormat(number, format = 'TRY', lang = 'tr-TR') {
    return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: format,
    }).format(number)
}

function getInstallment(e, _package) {
    const $modal = $('#credit-card-modal');
    const $installmentList = $modal.find('#installment-list');
    const $installmentsForm = $modal.find('#installmentsForm');
    const $licensePeriod = $modal.find('#period').find(":selected").val();
    $.ajax({
        type: "POST",
        url: e.attr('data-installment-manager-endpoint'),
        dataType: "json",
        data: {
            "card_number": e.val().replace(/\D/g, '').substring(0, 8),
            "package": _package,
            "license_period": $licensePeriod
        },
        success: function (data) {
            if (data.length > 1) {
                $installmentList.html('');
                data.forEach((item) => {
                    $installmentList.append(`<tr class="cursor-pointer">
                        <td>
                            <input type="radio"
                            name="installment_amount"
                            value="${item.INSTALLMENT}"
                            id="installment_${item.INSTALLMENT}"
                            ${item.INSTALLMENT === 1 ? 'checked' : ''}
                            class="stylish-radio valign-middle mr-2">
                            <label for="installment_${item.INSTALLMENT}">${item.INSTALLMENT === 1 ? custom_translates.cash : item.INSTALLMENT + ' ' + custom_translates.installment}</label>
                        </td>
                        <td>${currencyFormat(item.AMOUNT_PER_INSTALLMENT, custom_translates.currency_code3, custom_translates.currency_locale)}</td>
                        <td>${currencyFormat(item.AMOUNT_TOTAL, custom_translates.currency_code3, custom_translates.currency_locale)}</td>
                    </tr>`);
                })
                $installmentsForm.show();
            }
        },
        error: function () {
            $installmentsForm.hide();
        }
    });
}

function cardModal(e) {
    const $modal = $('#credit-card-modal');
    const _package = $(e.currentTarget).attr('data-package');
    const price = $(e.currentTarget).attr('data-price');
    const $mask = $modal.find('[data-imask-mask]');
    if (_package) {
        $modal.find('#packageId').val(_package);
    }

    if (price) {
        const pricing_card = $modal.find('.pricing-card');
        if (pricing_card.length) {
            const ranges = [...Array(3).keys()].map(i => i + 1);
            const options = ranges.map(i => {
                return `<option value="${i}" ${i === 1 ? 'selected' : null}>${i} ${custom_translates.additional_license} = ${currencyFormat(i * price)}</option>`;
            });
            const template = `
            <div class="form-group input">
            <i class="feather icon-calendar"></i>
            <select id="period" class="custom-select" name="license_period" required>
            ${options.toString()}
            </select>
            </div>`;
            pricing_card.find('.templateAdditional').html(template);
        }
    }

    $modal.modal();

    $modal.find('#period').bind('change', function () {
        const e = $mask;
        e.data('success', false);
        maskKeyup(e);
    });

    $mask.on('keyup', function () {
        const e = $(this);
        maskKeyup(e);
    });

    function maskKeyup(e) {
        if (e.val().length === 19 && !e.data('success')) {
            e.data('success', true);
            getInstallment(e, _package);
        }

        if (e.val().length < 19 && e.data('success')) {
            e.data('success', false);
        }
    }
}

$(".submitCreditCard").submit(function (e) {
    e.preventDefault();
    const iframeModal = $('#threeDModal');
    const url = $(this).attr('action');
    const data = $(this).serialize();
    $.ajax({
        type: "POST",
        url: url,
        data: data,
        success: function (data) {
            if (data.url) {
                iframeModal.find('.modal-body iframe').attr('src', data.url);
                $('#credit-card-modal').modal('hide');
                iframeModal.modal();
            } else {
                toastr.error(data);
            }
        },
        error: function (data) {
            // TODO
        },
    });
});
